<script setup>

// 合作伙伴
const props = defineProps({
    partner: {
        type: Array,
        required: true,
        default: () => [],
    },
    footer: {
        type: Object,
        default: () => ({ webname: '汇来云' })
    }
})

// 将合作伙伴数组每7个分为一组
const groupedPartners = computed(() => {
    const groups = []
    for (let i = 0; i < props.partner.length; i += 7) {
        groups.push(props.partner.slice(i, i + 7))
    }
    return groups
})
console.log(groupedPartners);

</script>

<template>
    <div class="Heziyun-partners Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('index.cooperativePartner1') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('index.cooperativePartner2') }}</p>
            </div>

            <!-- 无缝滚动 -->
            <div class="partners-section" v-intersect="{ class: 'bottom-top', delay: 0 }">
                <div class="partners-track" v-for="(item, index) in groupedPartners"
                    :style="{ '--t': `${20 + index * 5}s`, }">
                    <div>
                        <!-- 实际logo组 -->
                        <a v-for="(items, index) in item" :href="items.url" class="partner-logo" target="_blank">
                            <img :src="items.img">
                        </a>
                    </div>

                    <div>
                        <!-- 重复的logo组（实现无缝滚动） -->
                        <a v-for="(items, index) in item" :href="items.url" class="partner-logo" target="_blank">
                            <img :src="items.img">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
// 合作伙伴
.Heziyun-partners {
    .Heziyun-defaultWidth {
        .partners-section {
            width: 100%;
            overflow: hidden;
            position: relative;
            mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
            display: flex;
            flex-direction: column;
            gap: 1.2rem;
            padding-bottom: 20px;

            &:hover {
                .partners-track {
                    animation-play-state: paused;
                }
            }

            @keyframes animationOne {
                from {
                    transform: translate(100%);
                    -webkit-transform: translate(100%);
                    -moz-transform: translate(100%);
                    -ms-transform: translate(100%);
                    -o-transform: translate(100%);
                }

                to {
                    transform: translate(-100%);
                    -webkit-transform: translate(-100%);
                    -moz-transform: translate(-100%);
                    -ms-transform: translate(-100%);
                    -o-transform: translate(-100%);
                }
            }

            @keyframes animationTwos {
                from {
                    transform: translate(0%);
                    -webkit-transform: translate(0%);
                    -moz-transform: translate(0%);
                    -ms-transform: translate(0%);
                    -o-transform: translate(0%);
                }

                to {
                    transform: translate(-200%);
                    -webkit-transform: translate(-200%);
                    -moz-transform: translate(-200%);
                    -ms-transform: translate(-200%);
                    -o-transform: translate(-200%);
                }
            }

            .partners-track {
                margin: 0 auto;
                transform: translateZ(0);
                backface-visibility: hidden;
                perspective: 1000px;
                will-change: transform;
                display: flex;

                div {
                    display: flex;
                    white-space: nowrap;
                }

                div:nth-child(1) {
                    animation: animationOne var(--t) linear infinite;
                    -webkit-animation: animationOne var(--t) linear infinite;
                }

                div:nth-child(2) {
                    animation: animationTwos var(--t) linear infinite;
                    -webkit-animation: animationTwos var(--t) linear infinite;
                    animation-delay: calc(var(--t) / -2);
                }
            }


            .partner-logo {
                flex: 0 0 auto;
                width: 11rem;
                height: 4rem;
                margin: 0 0.5rem;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: transparent;
                background: #fff;
                box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1), -8px -8px 20px 0 #fff, inset 0 4px 20px 0 hsla(0, 0%, 100%, .5);
                border-radius: 8px;

                &:hover {
                    box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .2), -8px -8px 20px 0 #fff;
                }
            }

            .partner-logo img {
                max-width: 75%;
                max-height: 75%;
                object-fit: contain;
            }
        }
    }
}

// 合作伙伴
@media (max-width: 768px) {
    .Heziyun-partners {
        .Heziyun-defaultWidth {
            .partners-section {

                .partners-track {
                    width: calc(35vw * 18);
                }


                .partner-logo {
                    width: 35vw;
                    height: 12vw;
                    margin: 0 2vw;
                }

                @keyframes scroll {
                    0% {
                        transform: translateX(0);
                        -webkit-transform: translateX(0);
                        -moz-transform: translateX(0);
                        -ms-transform: translateX(0);
                        -o-transform: translateX(0);
                    }

                    100% {
                        transform: translateX(calc(-43vw * var(--item-count)));
                        -webkit-transform: translateX(calc(-43vw * var(--item-count)));
                        -moz-transform: translateX(calc(-43vw * var(--item-count)));
                        -ms-transform: translateX(calc(-43vw * var(--item-count)));
                        -o-transform: translateX(calc(-43vw * var(--item-count)));
                    }
                }
            }
        }
    }


}
</style>